import { UtilService } from './../../../../../shared/services/util.service';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Loading, Segurado } from '@app/shared/models';
import { DocumentosService } from '@app/shared/services';

@Component({
  selector: 'app-modal-ver-documento',
  templateUrl: './modal-ver-documento.component.html',
  styleUrls: ['./modal-ver-documento.component.scss']
})
export class ModalVerDocumentoComponent implements OnInit {

  carregar = new Loading();
  titulo: string;
  idDocumento: number;
  idAutoAtendimento: number;
  fileUrl: SafeResourceUrl | null = null;
  fileType: string | null = null;

  constructor(
    private utilService: UtilService,
    private sanitizer: DomSanitizer,
    private documentoService: DocumentosService,
    public dialogRef: MatDialogRef<ModalVerDocumentoComponent>,
      @Optional()
      @Inject(MAT_DIALOG_DATA) public data: { titulo: string, idDocumento: number, idAutoAtendimento: number }
  ) {
    this.titulo = data.titulo;
    this.idDocumento = data.idDocumento;
    this.idAutoAtendimento = data.idAutoAtendimento;
  }

  ngOnInit(): void {
    this.documentoService.visualizarDocumento(this.idDocumento, this.carregar).subscribe(response => {
      this.tratarBlob(response)
    })
  }

  tratarBlob(data: Blob) {
    const mimeType = data.type;
    const blobUrl = window.URL.createObjectURL(new Blob([data], { type: mimeType }));

    switch (mimeType) {
      case 'application/pdf':
        this.fileType = 'pdf';
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        break;
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/gif':
        this.fileType = 'image';
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        break;
      default:
        // Handle other document types like DOC, DOCX, TXT, etc.
        this.fileType = 'default';
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        break;
    }
  }
}
